<template>
    <div>
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @goShowSelectAccountPopup="goShowSelectAccountPopup" pageName="accountNew" ref="table"
            @isPageSmall="isPageSmall"></common-table>
        <el-drawer :visible.sync="showSelectAccountPopup" :size="pageSmall ? '100%' : '50%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter">
                    选择账户
                    <i class="el-icon-close" @click="showSelectAccountPopup = false"></i>
                </div>
                <div class="setRuleContent">
                    <div class="flex alcenter mb-10">
                        <el-input clearable v-model="searchKeyWord" @input="gosearchAccountList"
                            @clear="searchAccountList = []; isSearching = false" placeholder="搜索账户名称或ID" size="medium"
                            class="handle-input2" />
                        <el-button class="fs18 searchBtn" type="primary" size="small" @click="gosearchAccountList()">
                            搜索
                        </el-button>
                    </div>
                    <div class="selectAccountBox">
                        <div class="selectTitleBox flex alcenter">
                            <div class="leftTitle flex alcenter">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                    @change="handleCheckAllChange">
                                </el-checkbox>
                                <span class="pr5 pl10 ">请选择账户</span>
                                <span class=" pr5 " :class="pageSmall ? 'fs12' : ' fs14'" v-if="accountList.length">
                                    ({{ isSearching ? searchAccountList.length : accountList.length
                                    }})
                                </span>
                            </div>
                            <div class="rightTitle flex-between">
                                <div class="flex alcenter">
                                    已选 <span v-if="selectedAccountList.length">( {{ selectedAccountList.length
                                    }}
                                        )</span>
                                    <span v-else>账户</span>
                                </div>
                                <div class="c_primary" v-if="selectedAccountList.length"
                                    @click="deleteselectedAccountList('')">
                                    清空
                                </div>
                            </div>

                        </div>
                        <div class="selectContentBox">
                            <div class="flex">
                                <div class="left left1">
                                    <el-checkbox-group v-model="checkedAccount" @change="handleCheckedCitiesChange">
                                        <div class="flex alcenter  pb20"
                                            v-for="(item, index) in isSearching ? searchAccountList : accountList"
                                            :key="index">
                                            <el-checkbox :label="item" class="w100percent">
                                                <div class=" flex alcenter">
                                                    <div class="h20"
                                                        :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                        {{ item.value }}</div>
                                                    <div class="c_999 " :class="pageSmall ? 'fs12' : ' fs14'">
                                                        ( {{ item.key }})
                                                    </div>
                                                </div>
                                            </el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                    <div class="pt50 nodata flex-center"
                                        v-if="isSearching ? !searchAccountList.length : !accountList.length">
                                        暂无数据
                                    </div>
                                </div>
                                <div class="left p5  ">
                                    <div class="flex-between alcenter selectedAccountBox pb20 mb10"
                                        v-for="(item, index) in selectedAccountList" :key="index">
                                        <div class="pl5 flex alcenter">
                                            <div :class="pageSmall ? 'overflow1_100 fs16' : 'overflow1_300 fs18'">
                                                {{
                                                    item.value
                                                }}
                                            </div>
                                            <div class="c_999 pl10"
                                                :class="pageSmall ? ' overflow1_100 fs12' : 'overflow1_300 fs14'">
                                                ({{ item.key }})
                                            </div>

                                        </div>
                                        <i class="el-icon-close cp" @click="deleteselectedAccountList(index)"></i>
                                    </div>
                                    <div class="pt50 nodata flex-center" v-if="!selectedAccountList.length">
                                        暂无数据
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18" round type="primary" size="small"
                        @click="showSelectAccountPopup = false">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="goSelectAccountGetData">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
// import request from "@/utils/axios";
// import message from "@/utils/message";

export default {
    name: 'accountNew',
    components: { CommonTable },
    data() {
        return {

            showSelectAccountPopup: false,
            accountList: [],

            // 规则名称
            ruleName: '',
            searchs: [
                {
                    name: '',
                    placeholder: '',
                    type: 'selectAccount',
                    select: true,
                    selectUrl: '',
                    selectData: [],
                },
                {
                    name: '',
                    placeholder: '',
                    type: 'startWithEndDateTime',
                    select: true,
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
                    valueKey: 'advertiserId',
                    selectData: [],
                },
                {
                    name: 'selectDateRange',
                    placeholder: '',
                    type: 'select',
                    select: true,
                    selectData: [],
                    selectValue: [{
                        value: '汇总',
                        key: 0
                    }, {
                        value: '按日',
                        key: 1
                    }]
                }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                // get: '/smartRoiRules/listByCondition?intelligentRegulationType=0',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'date',  // 字段名
                label: '日期',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'accountName',  // 字段名
                label: '账户名称',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'totalConsume',  // 字段名
                label: '整体消耗',  // 字段显示名称
                sort: true,  // 是否排序
                show: true,  // 是否展示
                sortable: 'custom',
            }, {
                field: 'totalOrders',  // 字段名
                label: '整体成交订单数',  // 字段显示名称
                sort: true,  // 是否排序
                show: true,  // 是否展示
                sortable: 'custom',
            }, {
                field: 'totalAmount',  // 字段名
                label: '整体成交金额(元)',
                show: true,  // 是否展示
                sortable: 'custom',
            }, {
                field: 'totalPayROI',  // 字段名
                label: '整体支付ROI',  // 字段显示名称
                sort: true,  // 是否排序
                show: true,  // 是否展示
                sortable: 'custom',
            }, {
                field: 'accountList',  // 字段名
                label: '整体成交订单成本',  // 字段显示名称
                sort: true,  // 是否排序
                show: true,  // 是否展示
                sortable: 'custom',
            }, {
                field: 'accountList',  // 字段名
                label: '用户实际支付金额(元)',  // 字段显示名称
                sort: true,  // 是否排序
                show: true,  // 是否展示
                sortable: 'custom',
            }
            ],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    this.showAddCreateRulePopup = true
                    this.editData.id = row.id
                    this.editData.monitoringTime = row.executeContent.monitoringTime

                    this.monitorStatus = row.status ? '启用' : '停用'
                    this.consumeMoney = row.executeContent.maxConsume
                    this.conditionValue = row.executeContent.conditionValue
                    this.executeConditionList = row.executeContent.conditionList
                    this.executeValue = row.executeContent.executeValue
                    if (this.executeValue == '缓冲执行') {
                        this.timeInputValue = row.executeContent.timeInputValue
                        this.consumeMoney_slow = row.executeContent.consumeMoney_slow
                    }
                    this.noticeValue = row.executeContent.noticeValue
                    if (row.executeContent.monitorToOpen) {
                        this.isLimitNotice = true
                        this.watchMinute = row.executeContent.monitorToOpen
                    }
                    if (row.executeContent.timeSelectActiveList.length) {
                        this.activeTimePeriodBox = 1
                        this.timeSelectActiveList = row.executeContent.timeSelectActiveList
                    }
                    if (row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }

                    this.ruleName = row.ruleName
                    this.wxContracts = row.noticeConfig && row.noticeConfig.wxNumber
                    if (row.noticeConfig && row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    this.$axios.post({
                        url: 'smartRoiRules/delete/' + row.id,
                        success: (res) => {
                            // this.loading = false
                            console.log('333', res)
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                // this.showAddCreateRulePopup = false
                                this.$refs.table.getData()
                            } else {
                                // this.$message.error(res.msg || '出错了')

                            }
                        },
                        error: () => {
                            this.loading = false
                            this.$message.error('出错了')
                        },
                    })
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }],
            buttons: [
                {

                }
            ],
            pageSmall: false,
            searchKeyWord: '',
            isIndeterminate: true,
            searchAccountList: [],
            checkedAccount: [],
            checkAll: false,
            isSearching: false,
            selectedAccountList: []
        }
    },
    mounted() {
    },
    beforeDestroy() {
        // window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        deleteselectedAccountList(index) {
            console.log(index, 'index')
            if (index === '') {
                console.log('handleCheckAllChange')
                this.handleCheckAllChange(false)
            } else {
                this.checkedAccount = this.checkedAccount.slice(0, index).concat(this.checkedAccount.slice(index + 1));
                this.selectedAccountList = this.checkedAccount
            }
            this.checkAll = false
        },
        goSelectAccountGetData() {
            this.showSelectAccountPopup = false
        },
        gosearchAccountList() {
            if (!this.searchKeyWord) return
            this.isSearching = true
            this.searchAccountList = []
            this.accountList.forEach((obj) => {
                if (obj.value.includes(this.searchKeyWord) || JSON.stringify(obj.key).includes(this.searchKeyWord)) {
                    this.searchAccountList.push(obj)
                }
            })
            console.log(this.searchAccountList)
        },
        handleCheckAllChange(e) {
            console.log(e)
            this.checkedAccount = e ? this.accountList : []
            this.selectedAccountList = this.checkedAccount
            this.isIndeterminate = false
            console.log(this.isIndeterminate, 'this.isIndeterminate')
        },
        handleCheckedCitiesChange(e) {
            console.log(e)
            this.selectedAccountList = e
            this.checkAll = e.length === this.accountList.length
            this.isIndeterminate = e.length > 0 && e.length < this.accountList.length
        },
        goShowSelectAccountPopup(list) {
            this.showSelectAccountPopup = true
            this.accountList = list
            this.selectedAccountList = this.accountList
            this.checkAll = true
            this.handleCheckAllChange(true)

            console.log(this.accountList)
        },

        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
    }
}
</script>

<style scoped>
* {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.createRuleTitle {
    background-color: #f9f9f9;
    padding: 15px 30px;
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.setRuleContent {
    overflow: scroll;
    height: 90vh;
    padding: 30px;
    box-sizing: border-box;
}

.monitorWayBox,
.monitorTargetBox {
    padding: 30px;
}

.monitorWayBox .way_box {
    font-size: 14px;
    cursor: pointer;
    width: 220px;
    /* height: 80px; */
    padding: 20px 0;
    border: 1px solid #ddd;
    color: #333;
    border-radius: 5px;
}

.monitorWayBox .way_info {
    color: #666;
}

.active_way_box {
    border-color: #346bf6 !important;
    color: #346bf6 !important;
}

.monitorTargetBox .monitorTargetContent {
    background-color: #f9f9f9;
    border-radius: 5px;
    padding: 15px;
}


/deep/ .searchBtn {
    border-radius: 0 50px 50px 0;
    height: 36px;
    box-sizing: border-box;
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.handle-input2 {
    width: 300px !important;
    height: 36px;
    box-sizing: border-box;
}

/deep/ .handle-input2 .el-input__inner {
    height: 36px !important;
    box-sizing: border-box;
}

.selectTitleBox .leftTitle,
.rightTitle {
    font-size: 15px !important;
    /* font-weight: 600 !important; */
    width: 50%;
    background-color: #f0f2f5;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
}

.selectContentBox {
    background-color: #fff;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}

.selectContentBox .accountBox {
    height: 30px;
}

.selectContentBox .left {
    width: 50%;
    padding: 10px;
    height: 250px;
    overflow: scroll;
}

.selectContentBox .left1 {
    border-right: 1px solid #d9d9d9;
}


.selectContentBox .nodata {
    /* width: 100%; */
    padding: 10px;
    height: 90%;
}


.selectedAccountBox {
    background-color: #f0f2f5;
    padding: 5px;
}

.productImg {
    height: 50px;
    width: 50px;
    border-radius: 5px;
}


.yuan_box {
    position: absolute;
    top: 5px;
    right: 5px;
}

.addCondition {
    background-color: #edf4ff;
    padding: 5px 0;
    width: 500px;
    color: #4389f9;
    cursor: pointer;
}

.w100 {
    width: 100px;
}

.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}



.yl-time-range-table {
    border-collapse: collapse;
    table-layout: fixed;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 4px;
    width: 773px;
    border: 1px solid #e4e9ed;
    background-color: #fff;
}

.table_head {
    background-color: #f0f2f5;
    color: #555;
    /* padding: 10px; */
    /* width: 600px; */
    text-align: center;
}

.time_select_box {
    height: 40px !important;
    cursor: pointer;
    /* width: 20px !important; */
}

.time_select_box_inactive:hover {
    background-color: #f0f2f5;
}

.time_select_box_active {
    background-color: #409eff;
}

.time_select_box_active2 {
    background-color: rgba(64, 158, 255, 0.7);
    border-color: rgba(64, 158, 255, 0.7);
}

.drawer_footer {
    z-index: 1;
    background: #fff;
    align-items: center;
    height: 64px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -4px 6px #00000014;
}

@media (max-width: 768px) {

    .setRuleContent {
        padding: 15px;
    }


    .handle-input2 {
        font-size: 14px;
        width: 200px !important;
        height: 36px;
    }



    .dateSelector {
        transform: scale(0.8) !important;
        margin-left: -40px !important;
    }

    .productImg {
        height: 30px;
        width: 30px;
    }

    .selectedAccountBox {
        padding: 3px;
    }
}
</style>
